import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-downloapp',
  templateUrl: './downloapp.component.html',
  styleUrls: ['./downloapp.component.css']
})
export class DownloappComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
